module.exports = __webpack_public_path__ + "static/media/Vector1.2d7552f4.svg";